<template>
  <NuxtLink
    v-if="partnerData?.permalink"
    :to="
      localePath({
        name: 'p-partnerPermalink',
        params: { partnerPermalink: partnerData.permalink },
      })
    "
    class="author"
  >
    {{ author }}
  </NuxtLink>
  <div v-else class="author">{{ author }}</div>
</template>

<script lang="ts" setup>
import type { Supplier } from '~/composables/types/event'

const partnerData = inject('partnerData') as Ref<Supplier>
const $localePath = useLocalePath()
const localePath = $localePath
withDefaults(
  defineProps<{
    date: string
    author: string
    context: string
  }>(),
  {
    date: '',
    author: '',
    context: 'homePage',
  }
)
</script>

<style lang="postcss" scoped>
.author {
  @apply text-xs text-gray-500 flex mb-0;
}
</style>
